import React, { Component } from 'react'
import { Icon } from 'antd';
import { Redirect, Link } from 'react-router-dom'
import MenuSider from '../../../../components/MenuSider'
import ScrollToTop from '../../../../components/ScrollToTop'

export default class CategoryMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category: [],
        }
    }

    componentWillMount() {
        if (this.props.location.state === undefined) {
            window.localStorage.removeItem("select_job")
            window.localStorage.removeItem("type_of_category")
            window.localStorage.removeItem("Select_Category")
            window.localStorage.removeItem("Detail_Category")
        }

        var cate = JSON.parse(window.localStorage.getItem('Category'))
        var type_cate1 = JSON.parse(window.localStorage.getItem('type_of_category'))

        this.setState({
            category: cate
        })

    }

    render() {
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        return (
            <div>
                <ScrollToTop />
                <MenuSider title="Master Category" >
                    <div style={{ width: "100%", marginTop: "10px" }}>
                        {
                            this.state.category.map((m, i) => {
                                return (
                                    <div onClick={() => this.handleClick2(m.PKCategoryID - 1)} style={{ width: "100%", borderBottom: "1px solid #EEE", height: "50px", marginBottom: "10px", padding: "5px", cursor: "pointer" }} key={'category_' + i}>
                                        <img src={"/images/" + m.Image_name} className="image-category" style={{ borderRadius: "30%", filter: "grayscale(100%)", objectFit: "contain" }} />
                                        <div style={{ display: "inline-block", width: "75%", textAlign: "left", paddingLeft: "15px", fontSize: "13px", lineHeight: "1" }}> {m.Category_Name} </div>
                                        <div style={{ display: "inline-block", width: "10%", textAlign: "right" }}> <Icon type={"right"} style={{ fontSize: "17px" }} /> </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: "70px", height: "70px", position: "fixed", right: "25px", bottom: "40px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "50%" }}>
                        <Link to="/master_new_jobtype">
                            <Icon type="plus" style={{ left: "25%", top: "25%", position: "relative", color: "white", fontSize: "35px" }} />
                        </Link>
                    </div>
                </MenuSider>
            </div>
        )
    }


}